import api from '@/api';
import { PageResult } from '@/core/request/PageResult';
import { API_BASE_URL } from '..';
import {
  Accessory,
  CreateVehicleAccessoryRequest,
  ListAccessoriesRequest,
  ListVehicleAccessoryQuery,
  VehicleAccessory,
} from './Accessory.types';

const CONTROLLER_URL = `${API_BASE_URL}/accessories`;

export async function listVehiclesAccessories(
  params?: ListVehicleAccessoryQuery,
): Promise<PageResult<VehicleAccessory>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<VehicleAccessory>;
}

export async function getAccessory(id: number): Promise<VehicleAccessory> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as VehicleAccessory;
}

export async function getAccessories(params?: ListAccessoriesRequest) {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<Accessory>;
}

export async function createVehiclesAccessory(
  obj: CreateVehicleAccessoryRequest,
): Promise<VehicleAccessory> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as VehicleAccessory;
}

export async function updateVehiclesAccessory(
  obj: CreateVehicleAccessoryRequest,
): Promise<VehicleAccessory> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as VehicleAccessory;
}

export async function deleteVehiclesAccessory(accessoryId: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${accessoryId}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function accessoryActivateOrInactivate(accessoryId: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${accessoryId}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function accessoryListByVehicle(vehicleId?: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/vehicle/${vehicleId}`,
    null,
  )) as unknown;

  return result as Accessory[];
}
